/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.TCAP.Title',
    defaultMessage: 'TCAP',
  },
});

export default messages;
